export default __webpack_public_path__ + "images/C9.6160d77.png";